import { TextStyleScheme } from "../text_style_scheme.js";
import { UIElement } from "../ui_element.js";

export class RoundedRectButton extends UIElement
{
  private static RADIUS = 10;

  private bk_color: string;
  private text: string;
  private text_color: string = '#fff';
  private radius: number;

  constructor(
    ctx: CanvasRenderingContext2D,
    x: number,
    y: number,
    width: number,
    height: number,
    bk_color: string,
    text: string,
    text_color?: string,
    radius?: number
  )
  {
    super( ctx, x, y, width, height, false, true );

    this.bk_color = bk_color;
    this.text = text;
    if ( text_color )
      this.text_color = text_color;
    this.radius = radius ?? RoundedRectButton.RADIUS;
  }

  name():string { return 'RoundedRectButton'; }

  setTextColor( color: string ): void
  {
    this.text_color = color;
    this.setShouldBeRendered();
  }

  setBkColor( color: string ): void
  {
    this.bk_color = color;
    this.setShouldBeRendered();
  }

  protected override syncDomContent( _node: HTMLElement ): boolean
  {
    return false;
  }

  render(): void
  {
    if ( !this.shouldBeRendered() )
      return;
    
    this.startRender();

    const w2 = this.rect.getW2();
    const h2 = this.rect.getH2();
    const r = this.radius;

    const x1 = -w2;
    const y1 = -h2;
    const x2 = w2;
    const y2 = h2;

    // Рисуем прямоугольник со скруглёнными краями
    this.ctx.beginPath();
    this.ctx.moveTo( x1 + r, y1 );

    this.ctx.lineTo( x2 - r, y1 );
    this.ctx.quadraticCurveTo( x2, y1, x2, y1 + r );

    this.ctx.lineTo( x2, y2 - r );
    this.ctx.quadraticCurveTo( x2, y2, x2 - r, y2 );

    this.ctx.lineTo( x1 + r, y2 );
    this.ctx.quadraticCurveTo( x1, y2, x1, y2 - r );

    this.ctx.lineTo( x1, y1 + r );
    this.ctx.quadraticCurveTo( x1, y1, x1 + r, y1 );

    this.ctx.closePath();
    this.ctx.fillStyle = this.bk_color;
    this.ctx.fill();

    // Рисуем текст по центру
    this.ctx.fillStyle = this.text_color;
    this.ctx.textAlign = 'center';
    this.ctx.textBaseline = 'middle';
    this.ctx.font = `bold 16px ${TextStyleScheme.geologica}`;
    this.ctx.shadowBlur = 8;
    this.ctx.shadowColor = 'rgba(0, 0, 0, 0.5)';
    this.ctx.shadowOffsetX = 0;
    this.ctx.shadowOffsetY = 5;
    this.ctx.fillText( this.text, 0, 0 );

    this.finishRender();
  }
}
